import script from "./CollapseContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapseContainer.vue?vue&type=script&setup=true&lang=js"

import "./CollapseContainer.vue?vue&type=style&index=0&id=e97ed996&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e97ed996"]])

export default __exports__